import { useSyncExternalStore } from 'react';
import {
    subscribeSyncErrors,
    getSyncErrors,
    type SyncErrorEntry
} from './syncErrorLog';

/**
 * The reasons the sync has failed in this session, newest first.
 *
 * The log hands out the same array until something actually changes, which is
 * what lets `useSyncExternalStore` read it directly.
 */
export function useSyncErrors(): SyncErrorEntry[] {
    return useSyncExternalStore(subscribeSyncErrors, getSyncErrors);
}
